import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, Package, Tags, ShoppingBag, Users, TicketPercent, Newspaper, HelpCircle, ArrowLeft, Handshake, Gift, Mail, Truck, FileText, BellRing, Send, Landmark } from "lucide-react";
import { Link } from "react-router-dom";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, exact: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/categories", label: "Categories", icon: Tags },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/customers", label: "Customers", icon: Users },
  { to: "/admin/shipping", label: "Shipping", icon: Truck },
  { to: "/admin/coupons", label: "Coupons", icon: TicketPercent },
  { to: "/admin/discount-settings", label: "First-Time Discount", icon: Gift },
  { to: "/admin/discount-requests", label: "Discount Requests", icon: Mail },
  { to: "/admin/quote-requests", label: "Quote Requests", icon: FileText },
  { to: "/admin/restock-waitlist", label: "Restock Waitlist", icon: BellRing },
  { to: "/admin/newsletter", label: "Newsletter", icon: Send },
  { to: "/admin/tax-report", label: "Tax Report", icon: Landmark },
  { to: "/admin/blog", label: "Research Library", icon: Newspaper },
  { to: "/admin/faqs", label: "FAQs", icon: HelpCircle },
  { to: "/admin/affiliates", label: "Affiliate Applications", icon: Handshake },
];

export default function AdminLayout() {
  return (
    <div className="min-h-screen bg-slate-50 flex" data-testid="admin-layout">
      <aside className="w-60 bg-white border-r border-slate-200 flex flex-col shrink-0">
        <div className="p-5 border-b border-slate-200">
          <p className="font-display font-bold text-slate-900 text-sm">True Impact Peptides</p>
          <p className="text-[10px] uppercase tracking-wider text-slate-400">Admin Console</p>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.exact}
              data-testid={`admin-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-3 py-2 rounded-md text-sm font-medium transition-colors ${isActive ? "bg-gradient-to-r from-blue-900 to-blue-600 text-white shadow-blue-glow-sm" : "text-slate-600 hover:bg-blue-50 hover:text-blue-700"}`
              }
            >
              <l.icon className="h-4 w-4" strokeWidth={1.5} /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-slate-200">
          <Link to="/" className="flex items-center gap-2 text-xs text-slate-500 hover:text-slate-900 px-3 py-2" data-testid="admin-back-to-site">
            <ArrowLeft className="h-3.5 w-3.5" /> Back to Site
          </Link>
        </div>
      </aside>
      <main className="flex-1 p-8 overflow-x-auto">
        <Outlet />
      </main>
    </div>
  );
}
